// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.RentalManagerUserPropertyListWebApiHandler

import { frontEndRequestV2 } from '@zg-rentals/ts-client-fetch';
import type { RentalManagerEnvironment } from '@zg-rentals/rental-manager-env-base';

import type { RentalManagerUserPropertyListAtRiskDto, RentalManagerUserPropertyListDto } from '../..';

interface AtRiskParams {
  includeUserManagementCompanyId?: boolean;
  limit?: number;
  searchText?: string;
  startKeyExclusive?: string;
}
interface ListParams {
  includeActive?: boolean;
  includeArchived?: boolean;
  includeAtRisk?: boolean;
  includeFeedClaimAndConvertUpdate?: boolean;
  includeInactive?: boolean;
  includeListingCounts?: boolean;
  includeTours?: boolean;
  includeUnarchived?: boolean;
  includeUserManagementCompanyId?: boolean;
  limit?: number;
  offset?: number;
  searchText?: string;
  startKeyExclusive?: string;
}

export const RentalManagerUserPropertyListWebApiHandler_atRisk_Path = '/api/web/v1/users/properties/list/atRisk';

/**
 * List a user's properties that are at risk
 */
export const RentalManagerUserPropertyListWebApiHandler_atRisk = (
  getParams: AtRiskParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<AtRiskParams, never, RentalManagerUserPropertyListAtRiskDto>({
    getParams: getParams,
    endpoint: RentalManagerUserPropertyListWebApiHandler_atRisk_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerUserPropertyListWebApiHandler_list_Path = '/api/web/v1/users/properties/list';

/**
 * List a user's properties
 */
export const RentalManagerUserPropertyListWebApiHandler_list = (
  getParams: ListParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<ListParams, never, RentalManagerUserPropertyListDto>({
    getParams: getParams,
    endpoint: RentalManagerUserPropertyListWebApiHandler_list_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};
